/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.4",
    versionName: "0.2.0-nightly.2025.12.4",
    versionChannel: "nightly",
    buildDate: "2025-12-04T00:09:57.847Z",
    commitHash: "3e7bb32a517d2101337f899650693d15afaa9b54",
};
